import { NotificationManager as OriginalNotificationManager } from "react-notifications";
import { languageRef } from "hooks/use-translate-language";

const translate = key => {
  // languageRef is a function from use-translate-language hook, not a React ref object
  if (!languageRef || typeof languageRef !== "function") {
    return key;
  }
  return languageRef(key);
};

export function show(type, label, message) {
  OriginalNotificationManager[type](message, label);
}

export function successMsg(label, message, shouldTranslate = true) {
  OriginalNotificationManager.success(
    shouldTranslate ? translate(message) : message,
    shouldTranslate ? translate(label) : label
  );
}

export function errorMsg(label, message, shouldTranslate = true) {
  OriginalNotificationManager.error(
    shouldTranslate ? translate(message) : message,
    shouldTranslate ? translate(label) : label
  );
}

export function infoMsg(label, message, shouldTranslate = true) {
  OriginalNotificationManager.info(
    shouldTranslate ? translate(message) : message,
    shouldTranslate ? translate(label) : label
  );
}

export function warnMsg(label, message, shouldTranslate = true) {
  OriginalNotificationManager.warning(
    shouldTranslate ? translate(message) : message,
    shouldTranslate ? translate(label) : label
  );
}

const NotificationManager = {
  success: (label, message, shouldTranslate = true) => {
    if (message === undefined) {
      message = label;
      label = "";
    }
    successMsg(label, message, shouldTranslate);
  },
  error: (label, message, shouldTranslate = true) => {
    if (message === undefined) {
      message = label;
      label = "";
    }
    errorMsg(label, message, shouldTranslate);
  },
  info: (label, message, shouldTranslate = true) => {
    if (message === undefined) {
      message = label;
      label = "";
    }
    infoMsg(label, message, shouldTranslate);
  },
  warning: (label, message, shouldTranslate = true) => {
    if (message === undefined) {
      message = label;
      label = "";
    }
    warnMsg(label, message, shouldTranslate);
  }
};

export default NotificationManager;

